import { render } from "./InvoiceTemplate.ce.vue?vue&type=template&id=98a429fc&scoped=true"
import script from "./InvoiceTemplate.ce.vue?vue&type=script&lang=js"
export * from "./InvoiceTemplate.ce.vue?vue&type=script&lang=js"

import _style_0 from "./InvoiceTemplate.ce.vue?vue&type=style&index=0&id=98a429fc&inline&scoped=true&lang=css"

import exportComponent from "/Users/romain/Developer/vue-document-editor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]],['__scopeId',"data-v-98a429fc"]])

export default __exports__